/**
 * 灰色-1
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFFFFF
 */
var $color_grey_1 = '#FFFFFF';

/**
 * 灰色-2
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #F5F5F7
 */
var $color_grey_2 = '#F5F5F7';

/**
 * 灰色-3
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: E3E3E6
 */
var $color_grey_3 = '#E3E3E6';

/**
 * 灰色-4
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #E3E3E6
 */
var $color_grey_4 = '#E3E3E6';

/**
 * 灰色-5
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #CACACC
 */
var $color_grey_5 = '#CACACC';

/**
 * 灰色-6
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #CACACC
 */
var $color_grey_6 = '#CACACC';

/**
 * 灰色-7
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #8D9099
 */
var $color_grey_7 = '#8D9099';

/**
 * 灰色-8
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #89898C
 */
var $color_grey_8 = '#89898C';

/**
 * 灰色-9
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #0B0B0D
 */
var $color_grey_9 = '#0B0B0D';

/**
 * 灰色-10
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #030405
 */
var $color_grey_10 = '#030405';

/**
 * 橙色-1
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFE5D9
 */
var $color_orange_1 = '#FFE5D9';

/**
 * 橙色-2
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFC9B0
 */
var $color_orange_2 = '#FFC9B0';

/**
 * 橙色-3
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFAF8A
 */
var $color_orange_3 = '#FFAF8A';

/**
 * 橙色-4
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFAB85
 */
var $color_orange_4 = '#FFAB85';

/**
 * 橙色-5
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FF793B
 */
var $color_orange_5 = '#FF793B';

/**
 * 橙色-6
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FF5F14
 */
var $color_orange_6 = '#FF5F14';

/**
 * 橙色-7
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #CC490C
 */
var $color_orange_7 = '#CC490C';

/**
 * 橙色-8
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #AB3811
 */
var $color_orange_8 = '#AB3811';

/**
 * 橙色-9
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #852407
 */
var $color_orange_9 = '#852407';

/**
 * 橙色-10
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #5E1400
 */
var $color_orange_10 = '#5E1400';

/**
 * 黄色-1
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFFCF2
 */
var $color_yellow_1 = '#FFFCF2';

/**
 * 黄色-2
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFF8D4
 */
var $color_yellow_2 = '#FFF8D4';

/**
 * 黄色-3
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFE29E
 */
var $color_yellow_3 = '#FFE29E';

/**
 * 黄色-4
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFD270
 */
var $color_yellow_4 = '#FFD270';

/**
 * 黄色-5
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFC042
 */
var $color_yellow_5 = '#FFC042';

/**
 * 黄色-6
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFAA00
 */
var $color_yellow_6 = '#FFAA00';

/**
 * 黄色-7
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #D18706
 */
var $color_yellow_7 = '#D18706';

/**
 * 黄色-8
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #AB6900
 */
var $color_yellow_8 = '#AB6900';

/**
 * 黄色-9
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #855000
 */
var $color_yellow_9 = '#855000';

/**
 * 黄色-10
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #5E3700
 */
var $color_yellow_10 = '#5E3700';

/**
 * 红色-1
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FCD7DD
 */
var $color_red_1 = '#FCD7DD';

/**
 * 红色-2
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFDBD6
 */
var $color_red_2 = '#FFDBD6';

/**
 * 红色-3
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FFB6AD
 */
var $color_red_3 = '#FFB6AD';

/**
 * 红色-4
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #FF8F85
 */
var $color_red_4 = '#FF8F85';

/**
 * 红色-5
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #F53D5C
 */
var $color_red_5 = '#F53D5C';

/**
 * 红色-6
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #F2183D
 */
var $color_red_6 = '#F2183D';

/**
 * 红色-7
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #C2102E
 */
var $color_red_7 = '#C2102E';

/**
 * 红色-8
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #AB1411
 */
var $color_red_8 = '#AB1411';

/**
 * 红色-9
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #850707
 */
var $color_red_9 = '#850707';

/**
 * 红色-10
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #5E0000
 */
var $color_red_10 = '#5E0000';

/**
 * 绿色-1
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #E4F7F1
 */
var $color_green_1 = '#E4F7F1';

/**
 * 绿色-2
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #C0EDE0
 */
var $color_green_2 = '#C0EDE0';

/**
 * 绿色-3
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #8BE0C5
 */
var $color_green_3 = '#8BE0C5';

/**
 * 绿色-4
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #5BD4AB
 */
var $color_green_4 = '#5BD4AB';

/**
 * 绿色-5
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #13BF86
 */
var $color_green_5 = '#13BF86';

/**
 * 绿色-6
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #09BA78
 */
var $color_green_6 = '#09BA78';

/**
 * 绿色-7
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #00945B
 */
var $color_green_7 = '#00945B';

/**
 * 绿色-8
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #006E42
 */
var $color_green_8 = '#006E42';

/**
 * 绿色-9
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #00472A
 */
var $color_green_9 = '#00472A';

/**
 * 绿色-10
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #002113
 */
var $color_green_10 = '#002113';

/**
 * 靛蓝-1
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #F2F3FF
 */
var $color_Indigo_1 = '#F2F3FF';

/**
 * 靛蓝-2
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #D5D8F2
 */
var $color_Indigo_2 = '#D5D8F2';

/**
 * 靛蓝-3
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #AAB0E6
 */
var $color_Indigo_3 = '#AAB0E6';

/**
 * 靛蓝-4
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #828CD9
 */
var $color_Indigo_4 = '#828CD9';

/**
 * 靛蓝-5
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #5E6DCC
 */
var $color_Indigo_5 = '#5E6DCC';

/**
 * 靛蓝-6
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #394EBF
 */
var $color_Indigo_6 = '#394EBF';

/**
 * 靛蓝-7
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #293C99
 */
var $color_Indigo_7 = '#293C99';

/**
 * 靛蓝-8
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #192A73
 */
var $color_Indigo_8 = '#192A73';

/**
 * 靛蓝-9
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #0D1A4D
 */
var $color_Indigo_9 = '#0D1A4D';

/**
 * 靛蓝-10
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #050C26
 */
var $color_Indigo_10 = '#050C26';

/**
 * 紫色-1
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #F3F2FF
 */
var $color_purple_1 = '#F3F2FF';

/**
 * 紫色-2
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #E2E0FF
 */
var $color_purple_2 = '#E2E0FF';

/**
 * 紫色-3
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #C5C2FF
 */
var $color_purple_3 = '#C5C2FF';

/**
 * 紫色-4
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #A6A3FF
 */
var $color_purple_4 = '#A6A3FF';

/**
 * 紫色-5
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #8785FF
 */
var $color_purple_5 = '#8785FF';

/**
 * 紫色-6
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #6666FF
 */
var $color_purple_6 = '#6666FF';

/**
 * 紫色-7
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #4C4ED9
 */
var $color_purple_7 = '#4C4ED9';

/**
 * 紫色-8
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #363AB3
 */
var $color_purple_8 = '#363AB3';

/**
 * 紫色-9
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #23288C
 */
var $color_purple_9 = '#23288C';

/**
 * 紫色-10
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #141A66
 */
var $color_purple_10 = '#141A66';

/**
 * 蓝色-1
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #F2F7FF
 */
var $color_blue_1 = '#F2F7FF';

/**
 * 蓝色-2
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #D4DBFA
 */
var $color_blue_2 = '#D4DBFA';

/**
 * 蓝色-3
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #B0CEFF
 */
var $color_blue_3 = '#B0CEFF';

/**
 * 蓝色-4
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #85B6FF
 */
var $color_blue_4 = '#85B6FF';

/**
 * 蓝色-5
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #3355FF
 */
var $color_blue_5 = '#3355FF';

/**
 * 蓝色-6
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #2B85FB
 */
var $color_blue_6 = '#2B85FB';

/**
 * 蓝色-7
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #1C6ED4
 */
var $color_blue_7 = '#1C6ED4';

/**
 * 蓝色-8
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #0E58AD
 */
var $color_blue_8 = '#0E58AD';

/**
 * 蓝色-9
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #044387
 */
var $color_blue_9 = '#044387';

/**
 * 蓝色-10
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: #003061
 */
var $color_blue_10 = '#003061';

/**
 * 文本内容的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-3
 */
var $color_brand_text_disabled = $color_orange_3;

/**
 * 文本内容的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-5
 */
var $color_brand_text_hover = $color_orange_5;

/**
 * 文本内容的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-6
 */
var $color_brand_text_defalut = $color_orange_6;

/**
 * 文本内容的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-7
 */
var $color_brand_text_active = $color_orange_7;

/**
 * 背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-5
 */
var $color_brand_bg_hover = $color_orange_5;

/**
 * 背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-6
 */
var $color_brand_bg_default = $color_orange_6;

/**
 * 背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-7
 */
var $color_brand_bg_active = $color_orange_7;

/**
 * 浅色背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-2
 */
var $color_brand_light_bg_hover = $color_orange_2;

/**
 * 浅色背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-1
 */
var $color_brand_light_bg_default = $color_orange_1;

/**
 * 浅色背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-3
 */
var $color_brand_light_bg_active = $color_orange_2;

/**
 * 边框的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-6
 */
var $color_brand_border_hover = $color_orange_6;

/**
 * 边框的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-4
 */
var $color_brand_border_default = $color_orange_4;

/**
 * 边框的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-orange-8
 */
var $color_brand_border_active = $color_orange_8;

/**
 * 文本内容的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-3
 */
var $color_warning_text_disabled = $color_yellow_3;

/**
 * 文本内容的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-5
 */
var $color_warning_text_hover = $color_yellow_5;

/**
 * 文本内容的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-8
 */
var $color_warning_text_defalut = $color_yellow_6;

/**
 * 文本内容的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-8
 */
var $color_warning_text_active = $color_yellow_7;

/**
 * 背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-5
 */
var $color_warning_bg_hover = $color_yellow_5;

/**
 * 背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-6
 */
var $color_warning_bg_default = $color_yellow_6;

/**
 * 背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-7
 */
var $color_warning_bg_active = $color_yellow_7;

/**
 * 浅色背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-2
 */
var $color_warning_light_bg_hover = $color_yellow_2;

/**
 * 浅色背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-2
 */
var $color_warning_light_bg_default = $color_yellow_2;

/**
 * 浅色背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-3
 */
var $color_warning_light_bg_active = $color_yellow_3;

/**
 * 边框的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-6
 */
var $color_warning_border_hover = $color_yellow_5;

/**
 * 边框的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-4
 */
var $color_warning_border_default = $color_yellow_4;

/**
 * 边框的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-yellow-8
 */
var $color_warning_border_active = $color_yellow_8;

/**
 * 文本内容的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-3
 */
var $color_success_text_disabled = $color_green_3;

/**
 * 文本内容的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-5
 */
var $color_success_text_hover = $color_green_5;

/**
 * 文本内容的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-8
 */
var $color_success_text_defalut = $color_green_6;

/**
 * 文本内容的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-8
 */
var $color_success_text_active = $color_green_7;

/**
 * 背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-5
 */
var $color_success_bg_hover = $color_green_5;

/**
 * 背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-6
 */
var $color_success_bg_default = $color_green_6;

/**
 * 背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-7
 */
var $color_success_bg_active = $color_green_7;

/**
 * 浅色背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-2
 */
var $color_success_light_bg_hover = $color_green_2;

/**
 * 浅色背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-1
 */
var $color_success_light_bg_default = $color_green_1;

/**
 * 浅色背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-3
 */
var $color_success_light_bg_active = $color_green_3;

/**
 * 边框的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-6
 */
var $color_success_border_hover = $color_green_5;

/**
 * 边框的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-4
 */
var $color_success_border_default = $color_green_4;

/**
 * 边框的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-green-8
 */
var $color_success_border_active = $color_green_8;

/**
 * 文本内容的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-1
 */
var $color_error_text_disabled = $color_red_1;

/**
 * 文本内容的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-5
 */
var $color_error_text_hover = $color_red_5;

/**
 * 文本内容的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-8
 */
var $color_error_text_default = $color_red_6;

/**
 * 文本内容的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-8
 */
var $color_error_text_active = $color_red_7;

/**
 * 背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-5
 */
var $color_error_bg_hover = $color_red_5;

/**
 * 背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-6
 */
var $color_error_bg_default = $color_red_6;

/**
 * 背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-7
 */
var $color_error_bg_active = $color_red_7;

/**
 * 浅色背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-2
 */
var $color_error_light_bg_hover = $color_red_2;

/**
 * 浅色背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-1
 */
var $color_error_light_bg_default = $color_red_1;

/**
 * 浅色背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-3
 */
var $color_error_light_bg_active = $color_red_3;

/**
 * 边框的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-6
 */
var $color_error_border_hover = $color_red_5;

/**
 * 边框的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-4
 */
var $color_error_border_default = $color_red_4;

/**
 * 边框的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-red-8
 */
var $color_error_border_active = $color_red_8;

/**
 * 文本内容的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-blue-3
 */
var $color_info_text_disabled = $color_grey_3;

/**
 * 文本内容的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color_grey7
 */
var $color_info_text_hover = $color_grey_7;

/**
 * 文本内容的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color_grey_8
 */
var $color_info_text_default = $color_grey_8;

/**
 * 文本内容的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color_grey_9
 */
var $color_info_text_active = $color_grey_9;

/**
 * 背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color_grey_7
 */
var $color_info_bg_hover = $color_grey_7;

/**
 * 背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: color_grey_8
 */
var $color_info_bg_default = $color_grey_8;

/**
 * 背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-blue-9
 */
var $color_info_bg_active = $color_grey_9;

/**
 * 浅色背景的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-blue-2
 */
var $color_info_light_bg_hover = $color_grey_2;

/**
 * 浅色背景的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-blue-1
 */
var $color_info_light_bg_default = $color_grey_1;

/**
 * 浅色背景的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-blue-3
 */
var $color_info_light_bg_active = $color_grey_3;

/**
 * 边框的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-5
 */
var $color_info_border_hover = $color_grey_5;

/**
 * 边框的默认态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color_grey_4
 */
var $color_info_border_default = $color_grey_4;

/**
 * 边框的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-blue-8
 */
var $color_info_border_active = $color_grey_8;

/**
 * 一级文本色-强调/正文标题
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-9
 */
var $color_neutral_primary_text = $color_grey_9;

/**
 * 一级文本色-强调/正文标题的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color_grey_5
 */
var $color_neutral_primary_text_disabled = $color_grey_5;

/**
 * 一级文本色-强调/正文标题的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-9
 */
var $color_neutral_primary_text_hover = $color_grey_9;

/**
 * 二级文本色-普通/正文标题
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-8
 */
var $color_neutral_secondary_text = $color_grey_8;

/**
 * 二级文本色-普通/正文标题的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color_grey_5
 */
var $color_neutral_secondary_text_disabled = $color_grey_5;

/**
 * 二级文本色-普通/正文标题的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-9
 */
var $color_neutral_secondary_text_hover = $color_grey_9;

/**
 * 三级文本色-次要信息
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-7
 */
var $color_neutral_tertiary_text = $color_grey_7;

/**
 * 三级文本色-次要信息的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color_grey_5
 */
var $color_neutral_tertiary_text_disabled = $color_grey_5;

/**
 * 三级文本色-次要信息的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-8
 */
var $color_neutral_tertiary_text_hover = $color_grey_8;

/**
 * 四级文本色-禁用置灰信息
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color_grey_5
 */
var $color_neutral_quaternary_text = $color_grey_5;

/**
 * 五级文本色-反白信息
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-1
 */
var $color_neutral_quinary_text = $color_grey_1;

/**
 * 一级填充色-重/特殊场景
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-4
 */
var $color_neutral_primary_fill = $color_grey_4;

/**
 * 二级填充色-深/灰底悬浮
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-2
 */
var $color_neutral_secondary_fill = $color_grey_2;

/**
 * 三级填充色-常规/白底悬浮
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-7
 */
var $color_neutral_tertiary_fill = $color_grey_2;

/**
 * 四级填充色-浅/禁用
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-1
 */
var $color_neutral_quaternary_fill = $color_grey_1;

/**
 * 五级填充色-反白信息
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-1
 */
var $color_neutral_quinary_fill = $color_grey_1;

/**
 * 一级边框色-强调内容边框
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-6
 */
var $color_neutral_primary_border = $color_grey_6;

/**
 * 二级边框色-普通内容边框
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-4
 */
var $color_neutral_secondary_border = $color_grey_4;

/**
 * 组件容器背景色
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-1
 */
var $color_neutral_bg_container = $color_grey_1;

/**
 * 组件容器背景色的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-2, opacity=50%
 */
var $color_neutral_bg_container_disabled = 'rgba(248, 248, 250, 0.5)';

/**
 * 组件容器背景色的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-3
 */
var $color_neutral_bg_container_hover = $color_grey_3;

/**
 * 组件容器浅色背景色
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-1
 */
var $color_neutral_light_bg_container = $color_grey_1;

/**
 * 组件容器浅色背景色的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-1, opacity=50%
 */
var $color_neutral_light_bg_container_disabled = 'rgba(255, 255, 255, 0.5)';

/**
 * 组件容器浅色背景色的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-2
 */
var $color_neutral_light_bg_container_hover = $color_grey_2;

/**
 * 组件容器深色背景色
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-1
 */
var $color_neutral_dark_bg_container = $color_grey_1;

/**
 * 组件容器深色背景色的禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-6, opacity=50%
 */
var $color_neutral_dark_bg_container_disabled = 'rgba(255, 255, 255, 0.5)';

/**
 * 组件容器深色背景色的悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-2
 */
var $color_neutral_dark_bg_container_hover = $color_grey_2;

/**
 * 组件容器深色背景色的激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-7
 */
var $color_neutral_dark_bg_container_active = $color_grey_7;

/**
 * 浮层容器背景色
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-1
 */
var $color_neutral_bg_elevated = $color_grey_1;

/**
 * 页面布局背景色
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-2
 */
var $color_neutral_bg_layout = $color_grey_2;

/**
 * 引起注意的背景色(反白信息)
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-9
 */
var $color_neutral_bg_spotlight = $color_grey_9;

/**
 * 引起注意的背景色(反白信息) 悬浮态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-8
 */
var $color_neutral_bg_spotlight_hover = $color_grey_8;

/**
 * 部分组件使用的二级主题色
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-9
 */
var $color_secondary_primary = $color_grey_9;

/**
 * 引起注意的背景色(反白信息) 激活态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-9，opacity=20%
 */
var $color_neutral_bg_spotlight_active = 'rgba(40, 43, 51, 0.2)';

/**
 * 引起注意的背景色(反白信息) 禁用态
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-9，opacity=50%
 */
var $color_neutral_bg_spotlight_disabled = 'rgba(40, 43, 51, 0.2)';

/**
 * 浮层的背景蒙层颜色
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: $color-grey-10, opacity=60%
 */
var $color_neutral_bg_mask = 'rgba(3, 4, 5, 0.6)';

export { $color_Indigo_1, $color_Indigo_10, $color_Indigo_2, $color_Indigo_3, $color_Indigo_4, $color_Indigo_5, $color_Indigo_6, $color_Indigo_7, $color_Indigo_8, $color_Indigo_9, $color_blue_1, $color_blue_10, $color_blue_2, $color_blue_3, $color_blue_4, $color_blue_5, $color_blue_6, $color_blue_7, $color_blue_8, $color_blue_9, $color_brand_bg_active, $color_brand_bg_default, $color_brand_bg_hover, $color_brand_border_active, $color_brand_border_default, $color_brand_border_hover, $color_brand_light_bg_active, $color_brand_light_bg_default, $color_brand_light_bg_hover, $color_brand_text_active, $color_brand_text_defalut, $color_brand_text_disabled, $color_brand_text_hover, $color_error_bg_active, $color_error_bg_default, $color_error_bg_hover, $color_error_border_active, $color_error_border_default, $color_error_border_hover, $color_error_light_bg_active, $color_error_light_bg_default, $color_error_light_bg_hover, $color_error_text_active, $color_error_text_default, $color_error_text_disabled, $color_error_text_hover, $color_green_1, $color_green_10, $color_green_2, $color_green_3, $color_green_4, $color_green_5, $color_green_6, $color_green_7, $color_green_8, $color_green_9, $color_grey_1, $color_grey_10, $color_grey_2, $color_grey_3, $color_grey_4, $color_grey_5, $color_grey_6, $color_grey_7, $color_grey_8, $color_grey_9, $color_info_bg_active, $color_info_bg_default, $color_info_bg_hover, $color_info_border_active, $color_info_border_default, $color_info_border_hover, $color_info_light_bg_active, $color_info_light_bg_default, $color_info_light_bg_hover, $color_info_text_active, $color_info_text_default, $color_info_text_disabled, $color_info_text_hover, $color_neutral_bg_container, $color_neutral_bg_container_disabled, $color_neutral_bg_container_hover, $color_neutral_bg_elevated, $color_neutral_bg_layout, $color_neutral_bg_mask, $color_neutral_bg_spotlight, $color_neutral_bg_spotlight_active, $color_neutral_bg_spotlight_disabled, $color_neutral_bg_spotlight_hover, $color_neutral_dark_bg_container, $color_neutral_dark_bg_container_active, $color_neutral_dark_bg_container_disabled, $color_neutral_dark_bg_container_hover, $color_neutral_light_bg_container, $color_neutral_light_bg_container_disabled, $color_neutral_light_bg_container_hover, $color_neutral_primary_border, $color_neutral_primary_fill, $color_neutral_primary_text, $color_neutral_primary_text_disabled, $color_neutral_primary_text_hover, $color_neutral_quaternary_fill, $color_neutral_quaternary_text, $color_neutral_quinary_fill, $color_neutral_quinary_text, $color_neutral_secondary_border, $color_neutral_secondary_fill, $color_neutral_secondary_text, $color_neutral_secondary_text_disabled, $color_neutral_secondary_text_hover, $color_neutral_tertiary_fill, $color_neutral_tertiary_text, $color_neutral_tertiary_text_disabled, $color_neutral_tertiary_text_hover, $color_orange_1, $color_orange_10, $color_orange_2, $color_orange_3, $color_orange_4, $color_orange_5, $color_orange_6, $color_orange_7, $color_orange_8, $color_orange_9, $color_purple_1, $color_purple_10, $color_purple_2, $color_purple_3, $color_purple_4, $color_purple_5, $color_purple_6, $color_purple_7, $color_purple_8, $color_purple_9, $color_red_1, $color_red_10, $color_red_2, $color_red_3, $color_red_4, $color_red_5, $color_red_6, $color_red_7, $color_red_8, $color_red_9, $color_secondary_primary, $color_success_bg_active, $color_success_bg_default, $color_success_bg_hover, $color_success_border_active, $color_success_border_default, $color_success_border_hover, $color_success_light_bg_active, $color_success_light_bg_default, $color_success_light_bg_hover, $color_success_text_active, $color_success_text_defalut, $color_success_text_disabled, $color_success_text_hover, $color_warning_bg_active, $color_warning_bg_default, $color_warning_bg_hover, $color_warning_border_active, $color_warning_border_default, $color_warning_border_hover, $color_warning_light_bg_active, $color_warning_light_bg_default, $color_warning_light_bg_hover, $color_warning_text_active, $color_warning_text_defalut, $color_warning_text_disabled, $color_warning_text_hover, $color_yellow_1, $color_yellow_10, $color_yellow_2, $color_yellow_3, $color_yellow_4, $color_yellow_5, $color_yellow_6, $color_yellow_7, $color_yellow_8, $color_yellow_9 };
